module.exports = __webpack_public_path__ + "82f284ea4de9a8bc40fcfcb9a802ed09.pdf";